import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import BlogOne from '../../components/blog-one'
import TeamTwo from '../../components/team-two'
import Footer from '../../components/footer'
import Partner from '../../components/partner'
import BusinessCta from '../../components/cta/business-cta'

import bg1 from '../../assets/images/business/01.jpg'
import bg2 from '../../assets/images/business/02.jpg'
import bg3 from '../../assets/images/business/03.jpg'
import aboutImg from '../../assets/images/business/about.jpg'
import progressImg from  '../../assets/images/business/fluctuation.jpg'

import { Carousel } from 'react-responsive-carousel';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css'

import { businessFeature, businessProgress } from '../../data/data'

export default function IndexBusiness() {
  return (
    <>
     <Navbar navLight={true}/> 

    <section className="home-slider position-relative">
      <div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
          <Carousel className='w-100 h-100' autoPlay={true} infiniteLoop={true} showArrows={false} showStatus={false}>
                  <div className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
                      <div className="bg-overlay"></div>
                      <div className="container">
                          <div className="row justify-content-center mt-5">
                              <div className="col-lg-12 text-center">
                                  <div className="title-heading mt-4">
                                      <i className="uil uil-briefcase h1 text-white title-dark"></i>
                                      <h1 className="heading text-white title-dark fw-normal mb-3"><span className="fw-bold">Easy Business</span> With Leaping</h1>
                                      <p className="para-desc mx-auto text-light title-dark">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                                      <Link to="#" className="btn btn-primary mt-2">Get Started <i className="mdi mdi-chevron-right"></i></Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg2})`, backgroundPosition:'center'}}>
                      <div className="bg-overlay"></div>
                      <div className="container">
                          <div className="row justify-content-center mt-5">
                              <div className="col-lg-12 text-center">
                                  <div className="title-heading mt-4">
                                      <h1 className="h2"><i className="uil uil-bar-chart text-white title-dark"></i></h1>
                                      <h1 className="heading text-white title-dark fw-normal mb-3">Unleash Creativity in Business</h1>
                                      <p className="para-desc mx-auto text-light title-dark">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                                      <Link to="#" className="btn btn-outline-primary mt-2"><i className="mdi mdi-bookmark"></i> Documentation</Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg3})`, backgroundPosition:'center'}}>
                      <div className="bg-overlay"></div>
                      <div className="container">
                          <div className="row justify-content-center mt-5">
                              <div className="col-lg-12 text-center">
                                  <div className="title-heading mt-4">
                                      <h1 className="h2"><i className="uil uil-ruler text-white title-dark"></i></h1>
                                      <h1 className="heading text-white title-dark fw-normal mb-3">Start Your Business With Leaping</h1>
                                      <p className="para-desc mx-auto text-light title-dark">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                                      <Link to="#" className="btn btn-primary mt-2"><i className="mdi mdi-phone"></i> Contact us</Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
          </Carousel>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <Partner/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6">
                  <div className="me-md-4">
                      <img src={aboutImg} className="img-fluid rounded shadow" alt=""/>
                  </div>
              </div>

              <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Our Leaping Story</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space. These alternatives to the classic Lorem Ipsum texts are often amusing and tell short, funny or nonsensical stories.</p>
                      <Link to="#" className="btn btn-outline-primary mt-2">Read More <i className="mdi mdi-chevron-right"></i></Link>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Brilliant Choice for your Business</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {businessFeature.map((item,index)=>{
              return(
                <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                    <div className="card feature border-0 shadow rounded text-center p-4 py-5">
                        <div className="content">
                            <i className={item.icon}></i>
                            <h4 className="title mt-3">{item.title}</h4>
                            <p className="text-muted">{item.desc}</p>
                            <Link to="#" className="text-primary">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6 order-1 order-md-2">
                  <div className="ms-md-4">
                      <img src={progressImg} className="img-fluid rounded shadow" alt=""/>
                  </div>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Leaping Profitability</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      {businessProgress.map((item,index)=>{
                        return(
                          <div className="progress-box mt-4" key={index}>
                              <h6 className="title text-muted">{item.title}</h6>
                              <div className="progress">
                                  <div className={`progress-bar progress-bar-striped position-relative ${item.color}`} style={{width:item.value}}>
                                      <div className="progress-value d-block text-muted h6">{item.value}</div>
                                  </div>
                              </div>
                          </div>
                        )
                      })}
                  </div>
              </div>
          </div>
      </div>
    </section>

    <BusinessCta/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Business Minds</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

         <TeamTwo/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Latest Blog & News</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <BlogOne/>
      </div>
    </section>

    <Footer/>
    </>
  )
}
